import * as React from 'react';
import './ModelsPartsResults.scss';
import SearchModelProduct from 'src/model/searchModelProduct.model';
import TabsForSearch from './../common/TabsForSearch';
import * as InfiniteScroll from 'react-infinite-scroller';
import {
  ifLoggedIn,
  goToPartDetail,
  goToModelDetail,
  partDetailUrl,
  modelDetailUrl
} from 'src/utils/navigation';
import Breadcrumbs from '../common/Breadcrumbs';
import { analyticsListNames } from 'src/analytics/constant';

export interface IModelsPartsResultsProps {
  searchedText: string;
  results: SearchModelProduct;
  page: number;
  isLoggedIn: boolean;
  loading: boolean;
  onSearchNextPage: () => void;
  onResetPage: ()=> void;
  t?: any;
  fireProductClickEvent?(data: any): void;
}

export interface IModelsPartsResultsState {
  currentTab: number;
  searchSearchPart: string;
  searchSearchModel: string;
  totalLoadedModels: number;
  totalLoadedProducts: number;
}

export class ModelsPartsResults extends React.Component<
  IModelsPartsResultsProps,
  IModelsPartsResultsState
> {
  public state: IModelsPartsResultsState = {
    currentTab: 0,
    searchSearchPart: '',
    searchSearchModel: '',
    totalLoadedModels: 0,
    totalLoadedProducts:0
  };

  // Select the tab that has results by default
  public componentDidMount() {
    this.props.onResetPage();
    if (this.props.results.modelsFound === 0) {
      this.setState({
        currentTab: 1
      });
    }
  }
  public componentDidUpdate(prevProps: IModelsPartsResultsProps) {
    if (prevProps.results === this.props.results) {
      return;
    }
    if (prevProps.results !== this.props.results) {
      const newModelsCount = this.props.results.models?.length || 0;
      const prevModelsCount = prevProps.results.models?.length || 0;

      const newProductsCount = this.props.results.products?.length || 0;
      const prevProductsCount = prevProps.results.products?.length || 0;

      if (newModelsCount > prevModelsCount) {
        this.setState(prevState => ({
          totalLoadedModels:
            prevState.totalLoadedModels + (newModelsCount - prevModelsCount)
        }));
      }

      if (newProductsCount > prevProductsCount) {
        this.setState(prevState => ({
          totalLoadedProducts:
            prevState.totalLoadedProducts + (newProductsCount - prevProductsCount)
        }));
      }
    }
    if (this.props.results.modelsFound === 0) {
      this.setState({
        currentTab: 1
      });
    } else if (this.props.results.productFound === 0) {
      this.setState({
        currentTab: 0
      });
    }
  }

  public selectTab = (index: number) => {
    this.setState({
      currentTab: index
    });
  };

  public handleSearchSearchInput = (text: any) => {
    this.setState({
      searchSearchPart: text
    });
  };

  public handleSearchSearchModelInput = (text: any) => {
    this.setState({
      searchSearchModel: text
    });
  };

  private getFilteredModels = () => {
    if (!this.state.searchSearchModel) {
      return this.props.results.models;
    }
    const searchTermModel = this.state.searchSearchModel.toLowerCase();
    return this.props.results.models.filter(model =>
      model.name?.toLowerCase().includes(searchTermModel) ||
      model.manufacturer?.toLowerCase().includes(searchTermModel) ||
      model.applianceType?.toLowerCase().includes(searchTermModel)
    );
  };

  private getFilteredProducts = () => {
    if (!this.state.searchSearchPart) {
      return this.props.results.products;
    }
    const searchTerm = this.state.searchSearchPart.toLowerCase();
    return this.props.results.products.filter(product =>
      product.name?.toLowerCase().includes(searchTerm) ||
      product.description?.toLowerCase().includes(searchTerm) ||
      product.manufacturer?.toLowerCase().includes(searchTerm)
    );
  };

 

  public highlightText = (completeText: string) => {
    if (completeText == null) {
      return completeText;
    }
    const searched = this.props.searchedText.toUpperCase();
    const complete = completeText.toLocaleUpperCase();
    return complete.replace(
      searched,
      '<span class="highlight">' + searched + '</span>'
    );
  };

  private handleOnSelectedPart = (text: string) => {
    this.fireProductClickEvent(text);
    ifLoggedIn(() => goToPartDetail(text));
  };

  private handleOnSelectedModel = (text: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(text, manufacturer));
  };

  private fireProductClickEvent = (productNumber: string) => {
    const productClicked = this.props.results.products.find(
      product => product.productNumber === productNumber
    );
    const position = this.props.results.products.indexOf(productClicked) + 1;
    productClicked['position'] = position;
    const page = Math.floor((position - 1) / 10) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.SEARCH_RESULTS,
      listPage: page
    });
  };

  public renderLoading() {
    return (
      <div key="loader0" className="search-results-scroller-loader">
        Loading...
      </div>
    );
  }

  public renderNotFound(text: string) {
    return (
      <div key="loader0" className="search-results-not-found">
        {text}
      </div>
    );
  }

  public renderModels() {
    const { t } = this.props;
    return (
      <div className="search-results-items">
        {this.props.results && this.props.results.models.length > 0 ? (
          <div className="results container-fluid">
            <div className="results-title row">
              <p className="col-md-3">{t('common.model')}</p>
              <p className="col-md-3 d-none d-md-block">
                {t('partClaim.manufacturer')}
              </p>
              <p className="col-md-3 d-none d-md-block">
                {t('modelsPage.applianceType')}
              </p>
            </div>
            <InfiniteScroll
              pageStart={0}
              initialLoad={false}
              loadMore={this.props.onSearchNextPage}
              hasMore={
                !this.props.loading &&
                this.props.page <= this.props.results.modelsFound / 10
              }
            >
              <div>
                {this.getFilteredModels().map(model => (
                  <a
                    className="search-result-item-part-link"
                    href={
                      this.props.isLoggedIn &&
                      modelDetailUrl(model.name, model.manufacturer)
                    }
                  >
                    <div
                      className="search-result-item search-result-item-model row"
                      key={`${this.props.page}-${model.id}`}
                      onClick={() =>
                        this.handleOnSelectedModel(
                          model.name,
                          model.manufacturer
                        )
                      }
                    >
                      <p
                        className="col-md-3"
                        dangerouslySetInnerHTML={{
                          __html: this.highlightText(model.name)
                        }}
                      />
                      <p
                        className="col-md-3"
                        dangerouslySetInnerHTML={{
                          __html: this.highlightText(model.manufacturer)
                        }}
                      />
                      {model.applianceType ? (
                        <p
                          className="col-md-3"
                          dangerouslySetInnerHTML={{
                            __html: this.highlightText(model.applianceType)
                          }}
                        />
                      ) : null}
                    </div>
                  </a>
                ))}
              </div>
            </InfiniteScroll>
            {this.props.loading && this.renderLoading()}
          </div>
        ) : (
          this.renderNotFound('No Models Found')
        )}
      </div>
    );
  }

  public renderParts() {
    const { t } = this.props;
    return (
      <div className="search-results-items">
        {this.props.results && this.props.results.products.length > 0 ? (
          <div className="results container-fluid">
            <div className="results-title row">
              <p className="col-md-4">Part </p>
              <p className="col-md-3">{t('partClaim.manufacturer')}</p>
              <p className="col-md-5 d-none d-md-block">
                {t('myOrders.description')}
              </p>
            </div>
            <InfiniteScroll
              pageStart={0}
              initialLoad={false}
              loadMore={this.props.onSearchNextPage}
              hasMore={
                !this.props.loading &&
                this.props.page <= this.props.results.productFound / 10
              }
            >
              <div>
                {this.getFilteredProducts().map(product => (
                  <a
                    className="search-result-item-part-link"
                    href={
                      this.props.isLoggedIn &&
                      partDetailUrl(product.productNumber)
                    }
                  >
                    <div
                      className="search-result-item search-result-item-part row"
                      key={`${this.props.page}-${product.id}`}
                      onClick={() =>
                        this.handleOnSelectedPart(product.productNumber)
                      }
                    >
                      <div className="col-md-4">
                        <span
                          className="name"
                          onClick={() =>
                            this.handleOnSelectedPart(product.productNumber)
                          }
                          dangerouslySetInnerHTML={{
                            __html: this.highlightText(product.name)
                          }}
                        />
                        {product.subPartNumber!==null && 
                        <span className='substitute-title'> (Sub: #{product.subPartNumber})</span>
                        }
                      </div>
                      <div className="col-md-3">
                        <p
                          className="name"
                          onClick={() =>
                            this.handleOnSelectedPart(product.productNumber)
                          }
                        >
                          {product.manufacturer}
                        </p>
                      </div>
                      <div className="col-md-5">
                        <p
                          className="description"
                          onClick={() =>
                            this.handleOnSelectedPart(product.productNumber)
                          }
                          dangerouslySetInnerHTML={{
                            __html: this.highlightText(product.description)
                          }}
                        />
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </InfiniteScroll>
            {this.props.loading && this.renderLoading()}
          </div>
        ) : (
          this.renderNotFound('No Parts Found')
        )}
      </div>
    );
  }

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-models-parts-results">
        <Breadcrumbs>
          {t('common.home')} / {t('common.search')}
          {this.props.searchedText.trim() &&
          this.props.searchedText !== 'undefined'
            ? ` / ${this.props.searchedText}`
            : ''}
        </Breadcrumbs>
        <div className="search-results-top">
          {this.props.searchedText &&
          this.props.searchedText !== 'undefined' ? (
            <p>
              {t('modelsPage.searchResultsFor')}{' '}
              <b> {this.props.searchedText} </b>
            </p>
          ) : (
            ''
          )}
        </div>
        <TabsForSearch
          currentTab={this.state.currentTab}
          selectTab={this.selectTab}
          tabTitles={[
            {
              title: `${t('product.models')}`,
              count: this.getFilteredModels().length,
              showCount: true,
              searchTitle: `${t('product.searchModelTitle')}`,
              searchHandler:this.handleSearchSearchModelInput 
            },
            {
              title: `${t('partClaim.parts')}`,
              count: this.getFilteredProducts().length,
              showCount: true,
              searchTitle: `${t('product.searchPartTitle')}`,
              searchHandler:this.handleSearchSearchInput 
            }
          ]}
          tabContents={[this.renderModels(), this.renderParts()]}
        />
      </div>
    );
  }
}

export default ModelsPartsResults;
